import React from 'react';

const GameLogEntry = ({
  log,
  matchData,
  teamOneColor,
  teamTwoColor,
  teamOneName,
  teamTwoName,
  findJerseyNumber,
  findPlayerName,
}) => {
  const isTeamOne = log.t_id === matchData.event_team_a_id;
  const teamColor = isTeamOne ? teamOneColor : teamTwoColor;
  const teamName = isTeamOne ? teamOneName : teamTwoName;
  return (
    <div className="flex-1">
      {/* Log action type */}
      <p
        className={`font-bebas text-[12px] lg:text-xl`}
        style={{ color: teamColor }}
      >
        {log.score_type === 'point1' && '1pt made'}
        {log.score_type === 'point2' && '2pt made'}
        {log.score_type === 'point3' && '3pt made'}
        {log.score_type === 'pointMiss1' && '1pt miss'}
        {log.score_type === 'pointMiss2' && '2pt miss'}
        {log.score_type === 'pointMiss3' && '3pt miss'}
        {log.score_type === 'assist' && 'Assist'}
        {log.score_type === 'offensiveRebound' && 'Offensive rebound'}
        {log.score_type === 'defensiveRebound' && 'Defensive rebound'}
        {log.score_type === 'block' && 'Block'}
        {log.score_type === 'steal' && 'Steal'}
        {log.score_type === 'turnover' && 'Turnover'}
        {log.score_type === 'personalFoul' && 'Personal Foul'}
        {log.score_type === 'foulDrawn' && 'Foul Drawn'}
        {log.score_type === 'technicalFoul' && 'Technical Foul'}
      </p>

      {/* Substitutions */}
      <p className={`font-bebas text-[8px] lg:text-xl`} style={{ color: teamColor }}>
        {!log.score_type && 'Substitutions'}
      </p>

      {!log.score_type && (
        <div className="flex flex-col gap-1 lg:gap-2 mt-1">
          {[1, 2, 3, 4, 5].map((idx) => (
            <React.Fragment key={idx}>
              {log[`r_id_${idx}_new`] && (
                <div className="flex gap-1 lg:gap-2 items-center">
                  <div className="max-w-[16px] lg:max-w-[34px] font-montserrat uppercase text-light font-semibold text-[4px] lg:text-[10px] w-full h-[10px] lg:h-5 bg-[#63D799] rounded-sm flex justify-center items-center">
                    in
                  </div>
                  <p className="text-primary text-[8px] lg:text-xs font-montserrat font-semibold">
                    | # {findJerseyNumber(log.t_id, log[`r_id_${idx}_new`])} |{' '}
                    {findPlayerName(log.t_id, log[`r_id_${idx}_new`])}
                  </p>
                </div>
              )}

              {log[`r_id_${idx}_org`] && (
                <div className="flex gap-1 lg:gap-2 items-center">
                  <div className="max-w-[16px] lg:max-w-[34px] font-montserrat uppercase text-light font-semibold text-[4px] lg:text-[10px] w-full h-[10px] lg:h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center">
                    out
                  </div>
                  <p className="text-primary text-[8px] lg:text-xs font-montserrat font-semibold">
                    | # {findJerseyNumber(log.t_id, log[`r_id_${idx}_org`])} |{' '}
                    {findPlayerName(log.t_id, log[`r_id_${idx}_org`])}
                  </p>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      )}

      {/* Team and player info */}
      {log.score_type && (
        <p className="text-primary text-[8px] lg:text-xs font-montserrat font-semibold">
          {teamName} | # {findJerseyNumber(log.t_id, log.r_id)} |{' '}
          {findPlayerName(log.t_id, log.r_id)}
        </p>
      )}
    </div>
  );
};

export default GameLogEntry;
